import type { Channel, Metric } from "../../types/analytics";
import { CHANNEL_COLOR, CHANNEL_LABEL, CHANNEL_ORDER, deltaPct, int, pctStr, roasStr, yen } from "../../lib/analyticsCalc";

interface ChannelCardsProps {
  totals: Record<Channel, Metric>;
  prevTotals: Record<Channel, Metric>;
  channels: Record<Channel, boolean>;
  hasPrev: boolean;
}

export function ChannelCards({ totals, prevTotals, channels, hasPrev }: ChannelCardsProps) {
  const allSales = CHANNEL_ORDER.reduce((a, ch) => a + totals[ch].sales, 0) || 1;

  return (
    <section className="an-channel-grid">
      {CHANNEL_ORDER.map((ch) => {
        const m = totals[ch];
        const prev = prevTotals[ch];
        const share = m.sales / allSales;
        const delta = deltaPct(m.sales, prev.sales, hasPrev);
        return (
          <div className={`an-channel-card ${channels[ch] ? "" : "off"}`} key={ch}>
            <div className="an-channel-head">
              <span className="an-channel-sq" style={{ background: CHANNEL_COLOR[ch] }} />
              <span className="an-channel-name">{CHANNEL_LABEL[ch]}</span>
              <span className="an-channel-share">構成比 {pctStr(m.sales, allSales, 1)}</span>
            </div>
            <div className="an-channel-sales-row">
              <span className="an-channel-sales">{yen(m.sales)}</span>
              <span className="an-channel-delta" style={{ color: delta.color }}>
                {delta.text}
              </span>
            </div>
            <div className="an-bar-track">
              <div className="an-bar-fill" style={{ width: `${Math.min(100, share * 100)}%`, background: CHANNEL_COLOR[ch] }} />
            </div>
            <div className="an-channel-metrics">
              <div>
                <div className="an-channel-metric-label">アクセス</div>
                <div className="an-channel-metric-value">{m.sessions != null ? int(m.sessions) : "—"}</div>
              </div>
              <div>
                <div className="an-channel-metric-label">転換率</div>
                <div className="an-channel-metric-value">{m.sessions ? pctStr(m.orders, m.sessions) : "—"}</div>
              </div>
              <div>
                <div className="an-channel-metric-label">広告費</div>
                <div className="an-channel-metric-value">{yen(m.ad_spend)}</div>
              </div>
              <div>
                <div className="an-channel-metric-label">ROAS</div>
                <div className="an-channel-metric-value">{roasStr(m.sales, m.ad_spend)}</div>
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
}
